// extracted by mini-css-extract-plugin
module.exports = {"btnGroup":"TicTacToe_btnGroup__1ejVL"};